"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TournamentSignUpAthleteDto = /** @class */ (function () {
    function TournamentSignUpAthleteDto() {
    }
    return TournamentSignUpAthleteDto;
}());
exports.default = TournamentSignUpAthleteDto;
